import { logger } from 'shared/lib'
import { type Campaign, CampaignApi } from 'entities/Campaign'
import { showWebhookActionModal } from 'widgets/EnrollByWebhook/actions/webhookAction/webhookAction.tsx'
import { CampaignEnrolmentStore } from 'pages/campaigns/ui/CampaignEnrolment'
import { openDisableCampaignModal } from './openDisableCampaignModal'

export const toggleActiveCampaign = async (campaign: Campaign): Promise<void> => {
  if (campaign.status === 'active') {
    openDisableCampaignModal(campaign.id, (data) => {
      campaign.syncOrigin(data)
    })
    return
  }

  if (campaign.status === 'disabled') {
    try {
      const { data } = await CampaignApi.patch(campaign.id, { status: 'active' })
      campaign.syncOrigin(data.data)

      const campaignEnrolmentStore = new CampaignEnrolmentStore()
      await campaignEnrolmentStore.init({
        data: {
          name: data.data.name,
          id: data.data.id,
          filters: data.data.filters,
          exclude_filters: data.data.exclude_filters,
        },
        onNext: () => {
          if (data.data.settings.enroll_by_webhook && data.data.webhook_url) {
            showWebhookActionModal({
              webhookUrl: data.data.webhook_url,
              sourceName: data.data.name,
              source: 'campaign',
            })
          }
        },
      })
    } catch (error) {
      logger.error(error)
    }
  }
}
